import { render, staticRenderFns } from "./Carousel3Images.vue?vue&type=template&id=456f8de9&scoped=true"
import script from "./Carousel3Images.vue?vue&type=script&lang=js"
export * from "./Carousel3Images.vue?vue&type=script&lang=js"
import style0 from "./Carousel3Images.vue?vue&type=style&index=0&id=456f8de9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456f8de9",
  null
  
)

export default component.exports